import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'TopicContent' })({
    root: {
        display: 'flex',
        maxWidth: 856,
        width: '100%',
        boxSizing: 'border-box',
        padding: '64px 40px',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 64,
        borderRadius: 24,
        border: '1px solid rgba(255, 255, 255, 0.15)'
    },
    link: {
        height: 56,
        padding: '16px 32px',
        color: '#fff',
        fontSize: 16,
        fontWeight: 600,
        lineHeight: '16px',
        borderRadius: 56,
        background: '#232323 !important',
        '&:hover': {
            background: '#2D2D2D !important'
        },
        '&:active': {
            background: '#151515 !important'
        }
    }
});
